import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextLinkAnalysis"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.7565 13.503L3.53325 21H22.5V22.5H3C2.17192 22.4992 1.50083 21.8281 1.5 21V1.5H3V18.8873L6.438 12.7755C6.65869 12.3767 7.04847 12.0997 7.49762 12.0224C7.94677 11.9452 8.40672 12.0759 8.748 12.378L14.3243 17.2455L14.3768 17.1683L19.6268 9.33225L20.8725 10.1678L15.645 17.97C15.4256 18.3709 15.0354 18.65 14.5851 18.7279C14.1347 18.8059 13.6734 18.6743 13.332 18.3705L7.7565 13.503ZM12 7.5H6V9H12V7.5ZM6 4.5H15V6H6V4.5ZM15 1.5H6V3H15V1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextLinkAnalysis.vue"]]);
